/*
 * Count True Values
 - - - - - - - - - - -
 Returns the count of truthy values in an array
 @param values: values to be tested
 */
export const countTrueValues = (values: boolean[]): number => {
  return values.filter(Boolean).length;
};
